// 需要全局初始化的
import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators'
import store from '@/store'
import { getShopList, getWarehouseList } from '@/api/common'
import { getAppList } from '@/api/platform'

export interface ShopResponse {
  shopId: number
  shopName: string
}

export interface WarehouseResponse {
  warehouseId: number
  warehouseName: string
}

export interface AppResponse {
  id: number
  name: string
  logo: string
}

export interface IinitState {
  shopList: ShopResponse[]
  warehouseList: WarehouseResponse[]
  appList: AppResponse[]
}

@Module({ dynamic: true, store, name: 'init' })
class Init extends VuexModule implements IinitState {
  public shopList: ShopResponse[] = []
  public warehouseList: WarehouseResponse[] = []
  public appList: AppResponse[] = []

  @Mutation
  private SET_SHOP_LIST(shopLIst: ShopResponse[]) {
    this.shopList = shopLIst
  }

  @Mutation
  private SET_WAREHOUSE_LIST(warehouseList: WarehouseResponse[]) {
    this.warehouseList = warehouseList
  }

  @Mutation
  private SET_APP_LIST(appList: AppResponse[]) {
    this.appList = appList
  }

  // 获取店铺
  @Action
  public async GetShopList() {
    const { content } = await getShopList<ShopResponse[]>()
    const allShop = content.find(item => item.shopId === 0)
    const index = content.findIndex(item => item.shopId === 0)
    if (allShop) {
      content.splice(index, 1)
      content.unshift(allShop)
    }
    this.SET_SHOP_LIST(content)
  }

  // 获取仓库
  @Action
  public async GetWarehouseList() {
    const { content } = await getWarehouseList<WarehouseResponse[]>()
    this.SET_WAREHOUSE_LIST(content)
  }

  // 获取平台列表
  @Action
  public async GetAppList() {
    const { content } = await getAppList<AppResponse[]>()
    this.SET_APP_LIST(content)
  }
}

export const InitModule = getModule(Init)
